import Drawer from './CustomDrawer';
export default Drawer;
//# sourceMappingURL=Drawer.js.map